<div class="paypal-agreement-redirect">
  <loading-spinner [show]="true"></loading-spinner>
</div>
